import { render, staticRenderFns } from "./refAddPropDialog.vue?vue&type=template&id=26d4c924"
import script from "./refAddPropDialog.vue?vue&type=script&lang=js"
export * from "./refAddPropDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports